import { ShipmentDto, ShipmentModel } from '../types/shipment'

export const transformShipmentDto = ({
  id,
  status,
  status_title,
  status_updated_at,
}: ShipmentDto): ShipmentModel => ({
  id,
  status,
  statusTitle: status_title,
  statusUpdatedAt: status_updated_at,
})
